'use es6';

import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PagesList from './PagesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.parentPages.modal.${key}`;
const PagesModal = ({
  pages,
  onCloneForm,
  onClose
}) => /*#__PURE__*/_jsxs(UIModal, {
  "data-selenium": "form-used-on-pages-modal",
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header')
      })
    })]
  }), /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('body')
      })
    }), /*#__PURE__*/_jsx(PagesList, {
      pages: pages
    })]
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('confirm')
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: onCloneForm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('copy')
      })
    })]
  })]
});
export default PagesModal;